export const ACTION_RESET = 'FETCH_DETAILDATALIST_RESET';
export const ACTION_REQUEST = 'FETCH_DETAILDATALIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_DETAILDATALIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_DETAILDATALIST_ERROR';
